/* AUTO-GENERATED by scripts/gen_director_chat_types.py. */

export type Version = 1;
export type TurnId = string;
export type Mode = "summary" | "hidden";
export type Revision = number;
export type Status = "running" | "completed" | "awaiting_user" | "failed" | "cancelled";
export type StartedAt = string;
export type FinishedAt = string | null;
export type Id = string;
export type Kind = "thinking" | "tool" | "skill";
export type Action = "thinking" | "inspect" | "create" | "update" | "generate" | "search" | "skill" | "action";
export type Status1 = "running" | "completed" | "failed" | "cancelled";
export type StartedAt1 = string;
export type FinishedAt1 = string | null;
export type SkillName = string | null;
export type Text = string | null;
export type ToolName = string | null;
export type ToolInput = string | null;
export type ToolResult = string | null;
export type Activities = DirectorActivity[];

export interface DirectorTurnPresentation {
  version?: Version;
  turn_id: TurnId;
  mode: Mode;
  revision: Revision;
  status: Status;
  started_at: StartedAt;
  finished_at?: FinishedAt;
  activities?: Activities;
}
export interface DirectorActivity {
  id: Id;
  kind: Kind;
  action: Action;
  status: Status1;
  started_at: StartedAt1;
  finished_at?: FinishedAt1;
  skill_name?: SkillName;
  text?: Text;
  tool_name?: ToolName;
  tool_input?: ToolInput;
  tool_result?: ToolResult;
}

import Ajv from 'ajv'
const schema = {"definitions": {"DirectorActivity": {"additionalProperties": false, "properties": {"id": {"minLength": 1, "title": "Id", "type": "string"}, "kind": {"enum": ["thinking", "tool", "skill"], "title": "Kind", "type": "string"}, "action": {"enum": ["thinking", "inspect", "create", "update", "generate", "search", "skill", "action"], "title": "Action", "type": "string"}, "status": {"enum": ["running", "completed", "failed", "cancelled"], "title": "Status", "type": "string"}, "started_at": {"minLength": 1, "title": "Started At", "type": "string"}, "finished_at": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Finished At"}, "skill_name": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Skill Name"}, "text": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Text"}, "tool_name": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Tool Name"}, "tool_input": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Tool Input"}, "tool_result": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Tool Result"}}, "required": ["id", "kind", "action", "status", "started_at"], "title": "DirectorActivity", "type": "object"}}, "additionalProperties": false, "properties": {"version": {"const": 1, "default": 1, "title": "Version", "type": "integer"}, "turn_id": {"minLength": 1, "title": "Turn Id", "type": "string"}, "mode": {"enum": ["summary", "hidden"], "title": "Mode", "type": "string"}, "revision": {"minimum": 0, "title": "Revision", "type": "integer"}, "status": {"enum": ["running", "completed", "awaiting_user", "failed", "cancelled"], "title": "Status", "type": "string"}, "started_at": {"minLength": 1, "title": "Started At", "type": "string"}, "finished_at": {"anyOf": [{"type": "string"}, {"type": "null"}], "default": null, "title": "Finished At"}, "activities": {"items": {"$ref": "#/definitions/DirectorActivity"}, "title": "Activities", "type": "array"}}, "required": ["turn_id", "mode", "revision", "status", "started_at"], "title": "DirectorTurnPresentation", "type": "object"}

const validatePresentation = new Ajv({ allErrors: true }).compile(schema)

function isDirectorTurnPresentation(value: object): value is DirectorTurnPresentation {
  return validatePresentation(value) === true
}

export function parseDirectorTurnPresentation(value: object): DirectorTurnPresentation {
  if (!isDirectorTurnPresentation(value)) {
    throw new Error(`Invalid Director turn presentation: ${JSON.stringify(validatePresentation.errors)}`)
  }
  return value
}
